export function SET_ACTION(state, data) {
  state.action = data;
}
